/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SessionProgressNoteModel } from '../../models/session-progress-note-model';

export interface GetSessionProgressNotes$Params {
  patientSessionID?: number;
}

export function GetSessionProgressNotes(http: HttpClient, rootUrl: string, params?: GetSessionProgressNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<SessionProgressNoteModel>> {
  const rb = new RequestBuilder(rootUrl, GetSessionProgressNotes.PATH, 'get');
  if (params) {
    rb.query('patientSessionID', params.patientSessionID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SessionProgressNoteModel>;
    })
  );
}

GetSessionProgressNotes.PATH = '/api/Staff/GetSessionProgressNotes';
